import { Site } from '../../common/constants/siteList'

export default [
  {
    key: 'elements',
    label: 'Envato Elements',
    imageSrc: '/images/cross-sell__elements.jpg',
    imageSrcSet: [
      '/images/cross-sell__elements.jpg',
      '/images/cross-sell__elements--2x.jpg'
    ],
    heading: 'Deliver better projects faster. Web, design & video assets',
    subHeading: 'Unlimited downloads, from $16.50/month',
    url: {
      base: { default: 'https://elements.envato.com/' },
      path: { default: 'pricing' },
      params: {
        [Site.themeforest]: {
          utm_source: 'themeforest.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'tf_global-footer',
          utm_medium: 'promos'
        },
        [Site.codecanyon]: {
          utm_source: 'codecanyon.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'cc_global-footer',
          utm_medium: 'promos'
        },
        [Site.graphicriver]: {
          utm_source: 'graphicriver.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'gr_global-footer',
          utm_medium: 'promos'
        },
        [Site.photodune]: {
          utm_source: 'photodune.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'pd_global-footer',
          utm_medium: 'promos'
        },
        [Site.videohive]: {
          utm_source: 'videohive.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'vh_global-footer',
          utm_medium: 'promos'
        },
        [Site.audiojungle]: {
          utm_source: 'audiojungle.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: 'aj_global-footer',
          utm_medium: 'promos'
        },
        [Site.threedocean]: {
          utm_source: '3docean.net',
          utm_campaign: 'elements_mkt-footer_17JULY2018',
          utm_content: '3do_global-footer',
          utm_medium: 'promos'
        }
      }
    }
  },
  {
    key: 'tutplus',
    label: 'Tuts+',
    imageSrc: '/images/cross-sell__tutsplus.jpg',
    imageSrcSet: [
      '/images/cross-sell__tutsplus.jpg',
      '/images/cross-sell__tutsplus--2x.jpg'
    ],
    heading: 'Learn almost anything with<br>Envato Tuts+ for free',
    subHeading: '25,000+ tutorials and 1,000+ courses',
    url: {
      base: {
        [Site.codecanyon]: 'https://webdesign.tutsplus.com',
        [Site.themeforest]: 'https://webdesign.tutsplus.com',
        default: 'http://tutsplus.com'
      },
      path: {
        [Site.codecanyon]: '/courses/a-beginners-guide-to-using-wordpress',
        [Site.themeforest]: '/courses/a-beginners-guide-to-using-wordpress',
        default: ''
      },
      params: {
        [Site.codecanyon]: {
          utm_source: 'EnvatoMarket',
          utm_medium: 'TF_Footer',
          utm_campaign: 'Envato_CC_Footer_FreeWPCourse'
        },
        [Site.themeforest]: {
          utm_source: 'EnvatoMarket',
          utm_medium: 'CC_Footer',
          utm_campaign: 'Envato_TF_Footer_FreeWPCourse'
        },
        default: {
          utm_source: 'market.envato.com',
          utm_medium: 'referral',
          utm_campaign: 'global_footer'
        }
      }
    }
  },
  {
    key: 'studio',
    label: 'Envato Studio',
    imageSrc: '/images/cross-sell__studio.jpg',
    imageSrcSet: [
      '/images/cross-sell__studio.jpg',
      '/images/cross-sell__studio--2x.jpg'
    ],
    heading: 'Designers matched perfectly to<br>you on Envato Studio',
    subHeading: '2000 artists ready to undertake your work',
    url: {
      base: {
        default: 'https://studio.envato.com'
      },
      path: {
        [Site.codecanyon]: '/explore/websites-programming',
        [Site.videohive]: '/explore/video-animation',
        [Site.audiojungle]: '/explore/audio',
        [Site.graphicriver]: '/explore/design-graphics',
        [Site.photodune]: '/explore/photo-editing',
        [Site.threedocean]: '/explore/3d-design-modeling',
        default: '/explore/wordpress'
      },
      params: {
        [Site.threedocean]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: '3docean'
        },
        [Site.audiojungle]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'audiojungle'
        },
        [Site.codecanyon]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'codecanyon'
        },
        [Site.graphicriver]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'graphicriver'
        },
        [Site.photodune]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'photodune'
        },
        [Site.themeforest]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'themeforest'
        },
        [Site.videohive]: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'videohive'
        },
        default: {}
      }
    }
  }
]
